<template>
  <div class="animated">
    <b-row>
      <b-col cols="2" class="pt-1">
        Sample
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            v-model="identifier"
            placeholder="Enter Sample Name"
            :state="!$v.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col v-if="sampleListLength > 1" cols="1" class="pl-0">
        <b-button variant="danger" block @click="onRemoveClick"
          ><i class="fal fa-trash"></i
        ></b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2" class="pt-1">
        Depth
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="number"
            min="0"
            placeholder="Start"
            v-model="depth_start"
            :state="!$v.depth_start.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="number"
            min="0"
            placeholder="End"
            v-model="depth_end"
            :state="!$v.depth_end.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="mt-0" />
  </div>
</template>
<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "IrrigationSampleFormGroup",
  mixins: [validationMixin, ToastNotifications],
  props: {
    sample: {
      type: Object,
      default: () => null
    },
    sampleListLength: {
      type: Number,
      default: 0
    }
  },
  computed: {
    identifier: {
      get() {
        return this.sample.identifier;
      },
      set(value) {
        this.sample_form.identifier = value;
      }
    },
    depth_start: {
      get() {
        return this.sample.sample_irrigation_suitability.depth_start;
      },
      set(value) {
        this.sample_form.depth_start = value;
      }
    },
    depth_end: {
      get() {
        return this.sample.sample_irrigation_suitability.depth_end;
      },
      set(value) {
        this.sample_form.depth_end = value;
      }
    }
  },
  data() {
    return {
      sample_form: {
        identifier: null,
        depth_start: null,
        depth_end: null
      }
    };
  },
  validations: {
    identifier: { required },
    depth_start: { required },
    depth_end: { required }
  },
  methods: {
    onRemoveClick() {
      this.$emit("onSampleListChange", {
        action: "remove",
        sample_id: this.sample.test_package_sample_id
      });
    }
  },
  watch: {
    sample_form: {
      handler(sample_form_data) {
        this.$emit("onSampleChange", {
          sample_form_data,
          sample_id: this.sample.test_package_sample_id
        });
      },
      deep: true
    }
  },
  created() {
    if (this.sample) {
      this.sample_form.identifier = this.sample.identifier;
      this.sample_form.depth_start = this.sample.sample_irrigation_suitability.depth_start;
      this.sample_form.depth_end = this.sample.sample_irrigation_suitability.depth_end;
    }
  }
};
</script>
